import { BaseComponentConfig } from '@interfaces/config/cms-components/base-config';
import { CmsComponentTypeEnum } from '@models/enums';
import { FreeText } from '@interfaces/config';
import { CmsComponentConfig, TextMediaBox } from '@interfaces/config';

export namespace SmallColumnModule {
  export const TypeEnum = CmsComponentTypeEnum.SMALL_COLUMN_MODULE;


  export interface ComponentConfig extends BaseComponentConfig {
    columns: TextMediaBox.ComponentConfig[];
    field_alignment?:string
    field_headline?:string
    title?:string
  }
}
